import { issueInitialCredential, type AdminUserSummary } from '@urbanik/api-client';
import {
  Button,
  CanonicalDefinitionList,
  CanonicalModal,
  CanonicalNotice,
  FormActions,
  StatePanel,
  canonicalStates,
  formatDateTime,
} from '@urbanik/ui';
import { useEffect, useState } from 'react';
import { apiBase } from './api-base';
export function InitialCredentialModal({
  user,
  onClose,
  onIssued,
}: {
  user: AdminUserSummary | null;
  onClose: () => void;
  onIssued: () => void;
}) {
  const [result, setResult] = useState<{ temporaryPassword: string; expiresAt: string } | null>(
    null,
  );
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [noticeVisible, setNoticeVisible] = useState(true);
  useEffect(() => {
    setResult(null);
    setError('');
    setNoticeVisible(true);
  }, [user]);
  async function issue() {
    if (!user) return;
    setBusy(true);
    setError('');
    try {
      setResult(await issueInitialCredential(apiBase, user.id));
      setNoticeVisible(true);
      onIssued();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'No se pudo generar la credencial.');
    } finally {
      setBusy(false);
    }
  }
  return (
    <CanonicalModal
      open={user !== null}
      title="Credencial inicial"
      eyebrow="Activación segura"
      description={user ? user.displayName + ' · ' + user.email : ''}
      onClose={() => !busy && onClose()}
    >
      {error ? (
        <CanonicalNotice message={error} tone="error" onDismiss={() => setError('')} />
      ) : null}
      {!result ? (
        <>
          <StatePanel
            state={{
              ...canonicalStates.find((s) => s.kind === 'empty')!,
              title: 'Cuenta lista para activar',
              message:
                'Genera una contraseña temporal válida durante 24 horas. Se mostrará una sola vez.',
            }}
          />
          <FormActions>
            <Button type="button" variant="secondary" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="button" variant="primary" disabled={busy} onClick={() => void issue()}>
              {busy ? 'Generando…' : 'Generar y activar'}
            </Button>
          </FormActions>
        </>
      ) : (
        <>
          {noticeVisible ? (
            <CanonicalNotice
              tone="success"
              autoHideMs={0}
              message="Copia esta contraseña ahora. No volverá a mostrarse."
              onDismiss={() => setNoticeVisible(false)}
            />
          ) : null}
          <CanonicalDefinitionList
            label="Entrega única"
            items={[
              { label: 'Contraseña temporal', value: result.temporaryPassword },
              { label: 'Expira', value: formatDateTime(result.expiresAt) },
            ]}
          />
          <FormActions>
            <Button type="button" variant="primary" onClick={onClose}>
              Ya la copié
            </Button>
          </FormActions>
        </>
      )}
    </CanonicalModal>
  );
}
